<template>
  <div id="app" :class="appClass">
    <transition name="fade" mode="out-in">
      <fcwpLoader v-if="loading == true && meta.loader" :image="meta.loader.loader_url.value" />
    </transition>
    <fcwpError v-if="item.error || meta.error" :itemError="item.error" :metaError="meta.error"></fcwpError>
    <fcwpAccessibility v-if="accessibility" :data="meta.accessibility" />
    <fcwpCookieInfo
      v-if="!policyReaded && meta.privacy_policy"
      :content="meta.privacy_policy.content"
      :translations="meta.privacy_policy.translations"
      :cookiePageSwitch="cookiePageSwitch"
      :changeable="meta.privacy_policy.changeable"
    />
    <fcwpHeader
      v-if="meta && item.header"
      :meta="meta"
      :header="item.header"
      :langs="item.lang_switcher"
      :contrast="contrast"
      :switchers="item.switchers"
    />

    <fcwpContent :item_id="item.id" :item="item.content" :scripts="item.footer" />

    <fcwpHomeElements
      v-if="item.content && item.content.is_home"
      :menu="meta.menu.menu_home"
      :poster="meta.poster"
    ></fcwpHomeElements>
    <fcwpFooter
      v-if="meta.footer"
      :above="meta.footer['above-footer']"
      :primary="meta.footer['footer-primary']"
      :secondary="meta.footer['footer-secondary']"
      :name="meta.name"
      :pp_url="meta.privacy_policy.url"
      :pp_translations="meta.privacy_policy.translations"
    />
  </div>
</template>

<script>
import Vue from "vue";
import classNames from "classnames";

import fcwpError from "./components/fcwpError.vue";
import fcwpHeader from "./components/fcwpHeader.vue";
import fcwpContent from "./components/fcwpContent.vue";
import fcwpHomeElements from "./components/fcwpHomeElements.vue";
import fcwpFooter from "./components/fcwpFooter.vue";
import fcwpLoader from "./components/fcwpLoader.vue";
import fcwpAccessibility from "./components/fcwpAccessibility.vue";
import fcwpCookieInfo from "./components/fcwpCookieInfo.vue";
import VueScrollTo from "vue-scrollto";

import { api_connect } from "./plugins/api_connect.js";
import { stats_counter } from "./plugins/stats_counter.js";
import { autocomplete } from "./plugins/autocomplete.js";
import { frm_redirector } from "./plugins/frm_redirector.js";
import { fcwp_table } from "./plugins/fcwp_table.js";
import { fcwp_chart } from "./plugins/fcwp_chart.js";
import { fcwp_dynamic_data } from "./plugins/dynamic_data.js";
import { footer_loader } from "./plugins/footer_loader.js";
import { async_form } from "./plugins/async_form.js";
import { youtube_box } from "./plugins/youtube_box.js";
import { load_scripts } from "./plugins/load_scripts.js";

export default {
  name: "app",
  data() {
    return {
      url: fcwp_vue_data.url,
      nonce: fcwp_vue_data.nonce,
      api: {},
      meta: [],
      item: [],
      loading: true,
      accessibility: false,
      policyReaded: this.getCookie('policyReaded'),
      cookiePageSwitch: false,
      letters: this.getCookie('letters'),
      grayscale: this.getCookie('grayscale'),
      contrast: this.getCookie('contrast'),
      appClass: '',

    };
  },
  methods: {
    changeBoolean(value) {
      this[value] = !this[value];
    },

    getAccesibility(name) {
      this[name] = !this[name];
      this.setCookie(name, this[name]);

      let oppositeName = name === 'contrast' ? 'grayscale' : name === 'grayscale' ? 'contrast' : null;

      if (this[name] === true && oppositeName !== null) {
        this[oppositeName] = false;
        this.setCookie(oppositeName, false);
      }
      this.setAppClass();
    },

    setTrue(value) {
      this[value] = true;
    },

    setCookie(name, value) {
      value = value === true ? 'true' : value === false ? 'false' : value;
      this.$cookie.set(name, value, 365);
    },

    getCookie(name) {
      let value = this.$cookie.get(name);
      if (value === 'true') return true;
      if (value === 'false' || value === '' || value === null) return false;
      return value;
    },

    setCookieTrue(value) {
      this[value] = true;
      this.setCookie(value);
    },

    setAppClass() {
      this.appClass = classNames({
        "letters": this.letters,
        "contrast": this.contrast,
        "grayscale":  this.grayscale,
        [this.meta.domain]: true,
      });
    }


  },

  async mounted() {
    var vue = this;

    var api = new api_connect(vue);

    if (typeof fcwp_vue_data.sitemeta !== "undefined") {
      vue.meta = fcwp_vue_data.sitemeta;
      api.site_name = vue.meta.name;
    } else {
      vue.meta = await api.getMeta();
    }
    this.setAppClass();

    stats_counter();
    new autocomplete(vue.meta.rest_url);
    fcwp_table();
    youtube_box();
    async_form(vue, api);
    frm_redirector(vue, api, VueScrollTo);

    fcwp_vue_data.scripts = load_scripts();

    //przechwytuje eventy childów
    vue.$root.$on("emitChangeBoolean", vue.changeBoolean);
    vue.$root.$on("emitAccesibility", vue.getAccesibility);
    vue.$root.$on("emitPolicyReaded", vue.setCookieTrue);
    vue.$root.$on("emitChangeTrue", vue.setTrue);

    fcwp_chart(vue);
    fcwp_dynamic_data(api.url);

    var initial_url = api.getInitialHref();
    var href;

    api.getInitialLanguage();
    vue.item = await api.getUrl(initial_url, true);
    meybeSwitchLanguage();
    vue.loading = false;

    document.addEventListener("click", async function(e) {
      href = api.getClicks(e);
      if (e.target.classList.contains('frm_button')) return;
      if (href !== null && href !== undefined) {
        vue.loading = true;
        vue.item = await api.getUrl(href, true);
        meybeSwitchLanguage();
        vue.loading = false;
        VueScrollTo.scrollTo("#app", 300, {
          offset: -20,
          onDone: function() {
            VueScrollTo.scrollTo(".title-wrapper", 3000, {
              offset: -40
            });
          }
        });
      }
    });

    window.onpopstate = async function(event) {
      event.preventDefault();
      var href = window.location.href;

      vue.loading = true;
      href = api.my_url ? href.replace(api.my_url, api.url) : href;
      vue.item = await api.getUrl(href, false);

      meybeSwitchLanguage();
      vue.loading = false;

      VueScrollTo.scrollTo("#app", 300, {
        offset: -20,
        onDone: function() {
          VueScrollTo.scrollTo(".title-wrapper", 3000, {
            offset: -40
          });
        }
      });
    };

    async function meybeSwitchLanguage() {
      if (vue.item.language != api.previous_language) {
        var cookie = require("vue-cookie");
        cookie.set("pll_language", vue.item.language, { expires: "1Y" });
        document.getElementsByTagName("html")[0].lang = vue.item.language;
        api.previous_language = vue.item.language;
        vue.meta = await api.getMeta(vue.item.language);
        api.site_name = vue.meta.name;
        api.setPageName(vue.item.content.title, vue.item.content.is_home);
      }
    }
  },
  components: {
    fcwpError,
    fcwpHeader,
    fcwpContent,
    fcwpFooter,
    fcwpHomeElements,
    fcwpLoader,
    fcwpAccessibility,
    fcwpCookieInfo
  },
  watch: {
    item: function(newItem, oldItem) {
      footer_loader(newItem.footer);
    }
  }
};
</script>

<style lang="scss">
</style>
